"use client";
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@nextui-org/react";
import DownloadBrochureCourse from "../../../../../components/modal/DownloadBrochureCourse";
import { FillerBtn } from "../../../../../components/molecules";
import { useDictionary } from "../../../../../context/dictionaryProvider";
import { trackEvent } from "../../../../../lib/engageXClient";

// An on-site message (EngageX, see components/EngageXOnsite.jsx) can open this
// course's brochure form. Off until NEXT_PUBLIC_ENGAGEX_ONSITE_ENABLED is "true".
const ONSITE_ENABLED = process.env.NEXT_PUBLIC_ENGAGEX_ONSITE_ENABLED === "true";

const BrochureCourse = ({ course, location = "hero" }) => {
  const dict = useDictionary();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  // Where the form was opened from: this button, or an on-site message.
  const [from, setFrom] = useState(location);
  const hasBrochure = Boolean(course?.brochure);
  const courseName = course?.course_name;

  // Only the hero button answers, so one request opens one form. The message
  // offers a brochure only where window.LP.brochure says this page has one.
  useEffect(() => {
    if (!ONSITE_ENABLED || location !== "hero") return undefined;
    const mine = { path: window.location.pathname, available: hasBrochure };
    window.LP = window.LP || {};
    window.LP.brochure = mine;
    const onRequest = (e) => {
      if (!hasBrochure || e.defaultPrevented) return;
      e.preventDefault();
      setFrom("onsite");
      trackEvent("brochure_click", { course_name: courseName, location: "onsite" });
      onOpen();
    };
    window.addEventListener("lp:open-brochure", onRequest);
    return () => {
      window.removeEventListener("lp:open-brochure", onRequest);
      if (window.LP?.brochure === mine) delete window.LP.brochure;
    };
  }, [hasBrochure, courseName, location, onOpen]);

  const handleClick = (e) => {
    e.stopPropagation();
    trackEvent("brochure_click", { course_name: course?.course_name, location });
    setFrom(location);
    onOpen();
  };

  return (
    <>
      <FillerBtn
        onClick={handleClick}
        disabled={!course?.brochure}
        className={`${course?.brochure ? "" : "opacity-70"} !capitalize `}
      >
        {dict?.courses?.downloadBrochure}
      </FillerBtn>

      <DownloadBrochureCourse
        document={course?.brochure}
        course={{
          id: course?.id,
          name: course?.course_name,
          discountPrice: course?.discounted_price,
          price: course?.price,
          productId: course?.product_id,
        }}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        location={from}
      />
    </>
  );
};

export default BrochureCourse;
